import React, { memo } from 'react'

import { RewardSummary, RewardSummaryNS } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useFeature } from '@optimizely/react-sdk'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { ACCOUNT_ROUTES } from 'App/constants'
import optimizelyConstants from 'constants/optimizely'
import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import getAccountTracking from 'features/account/helpers/getAccountTracking'
import useOptimizelyDecision from 'features/account/hooks/useOptimizelyDecision'
import { trackOptimizelyEvent } from 'helpers/optimizely'
import { trackEventAdapter } from 'helpers/tracking'

import styles from './Reward.scss'
import RewardProps from './types'

const Reward: React.FC<RewardProps> = ({
  offerKey,
  offerPropositionId,
  pathWithQueries,
  type,
  Tag = 'li',
  className,
  dateInfoText,
  hideElement = false,
  ...props
}) => {
  const countdownTranslatedText = getLabelFromStorage('hub.register.by')
  const appState = useSelector((state) => state)
  const { trackEvent } = getAccountTracking(appState)

  const trackRewardClick = trackEvent(ACCOUNT_TRACKING_EVENTS.viewReward.id)
  const [isDonateVoucherEnabled] = useFeature(optimizelyConstants.DONATE_VOUCHER)
  const isNorthstarBrand = useOptimizelyDecision(optimizelyConstants.ACCOUNT_NORTHSTAR_VARIATION)

  const handleClick = (): any => {
    trackRewardClick()
    trackEventAdapter({
      ...ACCOUNT_TRACKING_EVENTS.viewOffersFromCarousel,
      event_label: `${offerKey}_${offerPropositionId} from carousel`,
    })
    if (isDonateVoucherEnabled) {
      trackOptimizelyEvent(optimizelyConstants.CLICK_ANY_INFO_TYPE_REWARDS_MY_ACCOUNT)
    }
  }

  const RenderComponent = !isNorthstarBrand ? RewardSummary : RewardSummaryNS
  const renderRewardCards = (): React.ReactElement => {
    return (
      <Link
        tabIndex={0}
        to={`${ACCOUNT_ROUTES.RewardDetail.path}/${offerPropositionId}`}
        onClick={handleClick}
        className={styles.linkDecoration}
      >
        <RenderComponent
          countdownTranslatedText={countdownTranslatedText}
          {...props}
          validFromText={`${props.validFromLabel} ${props.startDateTimeFormatted}`}
          validUntilText={getLabelFromStorage('hub.expires.at', {
            replacements: props.personalizedExpireDateFormatted,
          })}
          rewardSummaryType="small"
          brand={props.logo?.name}
          brandPositionSmall={`${props.logo?.position}_small`}
          brandColor={props.logo?.color || 'black'}
          bypassLp={false}
          dateInfoText={dateInfoText}
          className={styles.adjustSpacing}
        />
      </Link>
    )
  }
  return (
    <>
      {!hideElement ? (
        <Tag
          className={cn(
            styles.container,
            className,
            isNorthstarBrand && styles.allRewardsContainer,
          )}
        >
          {renderRewardCards()}
        </Tag>
      ) : (
        <>{renderRewardCards()}</>
      )}
    </>
  )
}

export default memo(Reward)
